import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import AppContent from "./components/AppContent";
import LoadingSpinner from "./components/common/LoadingSpinner";
import { NotificationProvider } from "./context/NotificationContext";
import { ThemeProvider } from "./hooks/useTheme";
import { AuthProvider } from "./hooks/useAuth";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Use global defaults for staleTime
      retry: 1,
    },
  },
});

const App = () => {
  return (
    <NotificationProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <Suspense fallback={<LoadingSpinner />}>
              <AppContent />
            </Suspense>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: "#1f2937",
                  color: "#fff",
                  border: "1px solid #374151",
                },
                success: {
                  style: {
                    background: "#10B981",
                    color: "#ffffff",
                    border: "1px solid #059669",
                  },
                  iconTheme: {
                    primary: "#ffffff",
                    secondary: "#10B981",
                  },
                },
                error: {
                  style: {
                    background: "#EF4444",
                    color: "#ffffff",
                    border: "1px solid #DC2626",
                  },
                  iconTheme: {
                    primary: "#ffffff",
                    secondary: "#EF4444",
                  },
                },
              }}
            />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </NotificationProvider>
  );
}

export default App;
